import { Typography } from "@mui/material";
import React from "react";

import { ChatAvatar } from "../primitives/ChatAvatar";
import { MessageBubble } from "../primitives/MessageBubble";

interface ErrorMessageProps {
  error?: string;
}

const ErrorMessageComponent: React.FC<ErrorMessageProps> = ({ error }) => (
  <MessageBubble variant="assistant" avatar={<ChatAvatar variant="assistant" />}>
    <Typography variant="body1" color="error" sx={{ lineHeight: 1.5 }}>
      {error || "I can't help you with that."}
    </Typography>
  </MessageBubble>
);

export const ErrorMessage = React.memo(ErrorMessageComponent);
